<template>
  <div>
    <Navbar v-if="this.$route.meta.navbar"/>
    <Breadcrumb v-if="this.$route.meta.navbar" />
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              name="file-import"
            /><br>Legacy Import
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <ConsultantLegacyImport />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="clipboard-list"
            /><br>Access Log
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_accesslog" />
        </b-card>
      </b-tab> 
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="globe"
            /><br>Get Browser
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <GetBrowser />
        </b-card>
      </b-tab> 
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="search"
            /><br>Track survey member
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <TrackSurveyMember />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="wrench"
            /><br>Generate test data
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <GenerateTestData />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="clipboard-list"
            /><br>Checklist
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_checklistitems" />
        </b-card>
      </b-tab> 
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="list"
            /><br>Add-on-surveys
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_addon_surveys" />
        </b-card>
      </b-tab>              
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="file-excel"
            /><br>Add-on Export
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <AddonSurveyExport />
        </b-card>
      </b-tab>  
    </b-tabs>
  </div>
</template>
<script>

import Maintenance from './Maintenance';
import ConsultantLegacyImport from './ConsultantLegacyImport';
import GetBrowser from './GetBrowser.vue';
import TrackSurveyMember from './TrackSurveyMember.vue';
import GenerateTestData from './GenerateTestData.vue';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import AddonSurveyExport from './AddonSurveyExport.vue';

export default {
  name: 'GDQUtils',
  mounted() {
  },
  components: {
    Maintenance,
    ConsultantLegacyImport,
    GetBrowser,
    TrackSurveyMember,
    GenerateTestData,
    Navbar,
    Breadcrumb,
    AddonSurveyExport,
  },
  data: function() {
    return {
    }
  },
  methods: {
  },
}
</script>
<style>
</style>
